import {
    addListener,
    createListenerMiddleware,
    type ListenerEffectAPI,
    type TypedAddListener,
    type TypedStartListening,
} from '@reduxjs/toolkit';

import { type AppDispatch, type RootState } from '.';

/**
 * This middleware lets you run additional logic when some action is dispatched, as a lighter-weight alternative to
 * middleware like sagas and observables that have both a heavy runtime bundle cost and a large conceptual overhead.
 * See redux-toolkit [Usage Guide](https://redux-toolkit.js.org/api/createListenerMiddleware#usage-guide)
 */
export const listenerMiddlewareInstance = createListenerMiddleware({
    // eslint-disable-next-line no-console
    onError: () => console.error,
});
export type AppListenerEffectAPI = ListenerEffectAPI<RootState, AppDispatch>;
// See https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
export type AppAddListener = TypedAddListener<RootState, AppDispatch>;
export const startAppListening = listenerMiddlewareInstance.startListening as AppStartListening;
export const addAppListener = addListener as AppAddListener;
